export default "/images/wordpress.svg?d7a42334aaedcebd9a1772f1bfa2656c";